// extracted by mini-css-extract-plugin
export default {"rangeSlider":"index_rangeSlider__sl7Y2","inputSpacer":"index_inputSpacer__FYfVX"};